import React, { Component } from "react";
import ProductRatingSection from "./ProductRatingSection";
import ProductPriceList from "./ProductPriceList";
import ProductVariants from "./variants/ProductVariants";
import ProductBuyBtn from "./ProductBuyBtn";

import sanitizeHtml from "sanitize-html";

import "./../../css/product-info.css";
import "./../../css/form-fields.css";

// Utils
import getInventory from '../../utils/inventoryUtils';

class ProductContent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			quantity: 1
		};

		this.quantityChange = this.quantityChange.bind(this);
	}

	quantityChange(event) {
		this.setState({ quantity: event.target.value });
	}

	renderShippingExempt(product) {
		if (product.shipping_exempt) {
			return (
				<div className="section shipping-exempt-section">
					<span className="icon-remove_shopping_cart" />
					Pickup item
				</div>
			);
		}
	}

	render() {
		const product = this.props.product;
		const variant = this.props.variant;
		const structure = this.props.structure;
		const inventory = getInventory(product, variant);

		return (
			<div className="product_info_section">
				{/* Title */}
				<h1>{product.title}</h1>
				<div className="model_number">Item #{product.sku}</div>

				{/* Prices */}
				{this.props.siteInfo.prices_shown && (
					<div className="prices">
						<ProductPriceList
							product={product}
							siteinfo={this.props.siteInfo}
							mainProduct={!!this.props.mainProduct ? this.props.mainProduct : 0}
						/>
					</div>
				)}

				{/* Shipping exempt */}
				{this.renderShippingExempt(product)}

				{/* Description */}
				<div
					className="product_description"
					dangerouslySetInnerHTML={{ __html: sanitizeHtml(product.description) }}
				/>

				{/* Rating */}
				<ProductRatingSection product={product} />

				{/* Limited Stock Notification */}
				{inventory != null && inventory <= 5 && inventory > 0 && <div className="limited_stock_notification">{`Limited Quantity: ${inventory} In Stock`}</div>}
				{inventory != null && inventory <= 0 && <div className="limited_stock_notification">{`Out of Stock`}</div>}

				{/* Variants */}
				<ProductVariants product={product} />

				{/* Quantity */}
				<div className="quantity_container">
					<div className="option_title">Quantity:</div>
					<input
						className="qty"
						type="number"
						min="1"
						step="1"
						placeholder="0"
						defaultValue={this.state.quantity}
						onChange={this.quantityChange}
					/>
				</div>

				{/* Add to cart */}
				<ProductBuyBtn
					product={product}
					structure={structure}
					quantity={this.state.quantity}
				/>
			</div>
		);
	}
}

export default ProductContent;



// WEBPACK FOOTER //
// ./src/components/product/ProductContent.js